<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  <select
    [id]="inputId"
    class="form-control"
    [class.valid-icon]="validation"
    [class.invalid-icon]="validation"
    [formControl]="control"
    >
    @if (placeholder) {
      <option
        class="placeholder"
        [value]="null"
        [disabled]="!canSelectPlaceholder"
        >
        {{ placeholder }}
      </option>
    }
    @for (itemValue of values; track itemValue) {
      <option [value]="value(itemValue)">
        {{display(itemValue)}}
      </option>
    }
  </select>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
